import { HTMLAttributeAnchorTarget, ReactElement } from 'react';
import cx from 'clsx';
import { TitleContainer } from 'components/TitleContainer';
import { EnterpriseLink } from 'components/EnterpriseLink';

export type CampaignWidgetProps = {
  id: number;

  title: string;
  number: string;
};

export function CampaignWidget({
  id,
  number,
  title,
  link,
  flat,
  target = '_blank',
}: CampaignWidgetProps & { link?: boolean; target?: HTMLAttributeAnchorTarget; flat?: boolean }): ReactElement {
  const content = link ? (
    <EnterpriseLink
      to={`/planning/campaigns/${id}/planning`}
      className={cx('text-nowrap', !flat && 'd-block')}
      target={target}
    >
      {number}
    </EnterpriseLink>
  ) : (
    number
  );

  return <TitleContainer title={content} flat={flat} subtitle={title} testId={`campaign-${id}`} />;
}
